import { ReactComponent as SuccessRingIconSVG } from '@/assets/icons/SuccessRingIcon.svg';
import { SVGProps } from 'react';

const SuccessRingIcon = (props: SVGProps<SVGSVGElement>) => <SuccessRingIconSVG {...props} />;

export default SuccessRingIcon;
